webpackJsonp([1],{

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {
/** Import frontoffice_app */

__webpack_require__(5);

var _filter_links = _interopRequireDefault(__webpack_require__(169));

var _pagination = _interopRequireDefault(__webpack_require__(8));

var _cart = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** @const TIRE_SEARCH */
var TIRE_SEARCH = 'tires/search';
/**
 * @class TiresSearchHandler
 */

var TiresSearchHandler =
/*#__PURE__*/
function () {
  /**
   * @constructor
   */
  function TiresSearchHandler() {
    _classCallCheck(this, TiresSearchHandler);

    this._setLinkActive();

    this._listenLinkByFilters();

    this.pagination = new _pagination.default({
      url: 'tire/pagination',
      activeStatistic: true,
      additionalFilters: [{
        selector: '#frontoffice-filter-tires-search',
        event: 'keyup',
        key: 'search',
        default: null
      }, {
        selector: '#frontoffice-filter-tires-seasonId',
        event: 'change',
        key: 'seasonId',
        default: null
      }, {
        selector: '#frontoffice-filter-tires-manufacturers',
        event: 'change',
        key: 'manufacturers',
        default: []
      }, {
        selector: '#frontoffice-filter-tires-widths',
        event: 'change',
        key: 'widths',
        default: []
      }, {
        selector: '#frontoffice-filter-tires-heights',
        event: 'change',
        key: 'heights',
        default: []
      }, {
        selector: '#frontoffice-filter-tires-diameters',
        event: 'change',
        key: 'diameters',
        default: []
      }, {
        selector: '.frontoffice-filter-tires-categoryId',
        event: 'click',
        key: 'categoryId',
        default: null,
        type: 'link'
      }, {
        selector: '#price-range-input-button',
        event: 'click',
        key: {
          from: 'priceLower',
          to: 'priceUpper',
          range: '#price-range-input'
        },
        default: null,
        type: 'range'
      }],
      responseCallbacks: [this._responseCallback]
    });
  }
  /**
   * @private
   */


  _createClass(TiresSearchHandler, [{
    key: "_listenLinkByFilters",
    value: function _listenLinkByFilters() {
      var that = this;
      $('.frontoffice-filter-tires-categoryId').on('click', function (e) {
        var category = [],
            filters = _filter_links.default.getFiltersCollectionFromLink(),
            catName = $(e.target)[0].innerText.split(' ')[0].replace('/', '$');

        if (catName !== 'Sve') {
          category = [catName];
        }

        filters['kategorija'] = category;

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-tires-heights').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['visina'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-tires-widths').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['širina'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-tires-diameters').on('change', function (e) {
        var filters = _filter_links.default.getFiltersCollectionFromLink();

        filters['prečnik'] = $(e.target).val();

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-tires-manufacturers').on('change', function (e) {
        var manufacturers = [],
            filters = _filter_links.default.getFiltersCollectionFromLink(),
            selected = $(e.target).val();

        $.each($('#frontoffice-filter-tires-manufacturers').find('option'), function (k, v) {
          if (selected.indexOf($(v).val()) >= 0) {
            manufacturers.push($(v)[0].innerText);
          }
        });
        filters['proizvođač'] = manufacturers;

        that.constructor._generateLinkFromFilters(filters);
      });
      $('#frontoffice-filter-tires-seasonId').on('change', function (e) {
        var season = [],
            filters = _filter_links.default.getFiltersCollectionFromLink(),
            selected = $(e.target).val();

        $.each($('#frontoffice-filter-tires-seasonId').find('option'), function (k, v) {
          if ($(v).val() === selected && $(v)[0].innerText !== 'Izaberite opciju') {
            season.push($(v)[0].innerText.split(' ')[0]);
          }
        });
        filters['sezona'] = season;

        that.constructor._generateLinkFromFilters(filters);
      });
    }
    /**
     * @private
     */

  }, {
    key: "_setLinkActive",
    value: function _setLinkActive() {
      var that = this;
      $('.frontoffice-filter-tires-categoryId').on('click', function (e) {
        that._handleCategoryLinks($(e.target));
      });
    }
    /**
     * @param response
     * @private
     */

  }, {
    key: "_responseCallback",
    value: function _responseCallback(response) {
      var that = this,
          links = $('.frontoffice-filter-tires-categoryId'),
          setted = [];

      if (response.statistic && response.statistic.totalByCat) {
        $.each(response.statistic.totalByCat, function (k, v) {
          $.each(links, function (a, b) {
            if ($(b).data('categoryid') && $(b).data('categoryid') === v.cat) {
              var text = $(b).text().split('(')[0];
              $(b).text(text + ' (' + v.total + ')');
              setted.push(v.cat);
            }
          });
        });
        $.each(links, function (c, d) {
          if ($(d).data('categoryid') && $(d).data('categoryid') > 0 && setted.indexOf($(d).data('categoryid')) < 0) {
            var text = $(d).text().split('(')[0];
            $(d).text(text + ' (0)');
          }
        });
      }

      if (response.statistic && response.statistic.manufacturer) {
        var manufacturersStr = '',
            manufacturerFilter = $('#frontoffice-filter-tires-manufacturers');
        $.each(response.statistic.manufacturer, function (k, v) {
          manufacturersStr += '<option value="' + v.id + '">' + v.name + '</option>';
        });
        var manVal = manufacturerFilter.val();
        manufacturerFilter.empty();
        manufacturerFilter.html(manufacturersStr);
        manufacturerFilter.val(manVal);
        manufacturerFilter.trigger("chosen:updated");
      }

      if (response.statistic && response.statistic.width) {
        var widthStr = '',
            widthFilter = $('#frontoffice-filter-tires-widths');
        $.each(response.statistic.width, function (k, v) {
          widthStr += '<option value="' + v.id + '">' + v.name + '</option>';
        });
        var widthVal = widthFilter.val();
        widthFilter.empty();
        widthFilter.html(widthStr);
        widthFilter.val(widthVal);
        widthFilter.trigger("chosen:updated");
      }

      if (response.statistic && response.statistic.height) {
        var heightStr = '',
            heightFilter = $('#frontoffice-filter-tires-heights');
        $.each(response.statistic.height, function (k, v) {
          heightStr += '<option value="' + v.id + '">' + v.name + '</option>';
        });
        var heightVal = heightFilter.val();
        heightFilter.empty();
        heightFilter.html(heightStr);
        heightFilter.val(heightVal);
        heightFilter.trigger("chosen:updated");
      }

      if (response.statistic && response.statistic.diameter) {
        var diameterStr = '',
            diameterFilter = $('#frontoffice-filter-tires-diameters');
        $.each(response.statistic.diameter, function (k, v) {
          diameterStr += '<option value="' + v.id + '">' + v.name + '</option>';
        });
        var diameterVal = diameterFilter.val();
        diameterFilter.empty();
        diameterFilter.html(diameterStr);
        diameterFilter.val(diameterVal);
        diameterFilter.trigger("chosen:updated");
      }

      $('.add_to_cart').on('click', function (e) {
        e.preventDefault();

        _cart.default.addToCart($(e.target).data('cartitem'));
      });
    }
    /**
     * @param selected
     * @private
     */

  }, {
    key: "_handleCategoryLinks",
    value: function _handleCategoryLinks(selected) {
      var links = $('.frontoffice-filter-tires-categoryId');
      links.css({
        'color': '',
        'font-weight': 'normal'
      });
      links.attr('data-selected', false);
      $.each(links, function (k, v) {
        if ($(v).data('categoryid') === selected.data('categoryid')) {
          selected.css({
            'color': '#428BCA',
            'font-weight': 'bold'
          });
          selected.attr('data-selected', true);
        }
      });
    }
    /**
     * @param filtersArray
     * @private
     */

  }], [{
    key: "_generateLinkFromFilters",
    value: function _generateLinkFromFilters(filtersArray) {
      _filter_links.default.generateLinkFromFilters(filtersArray, TIRE_SEARCH);
    }
  }]);

  return TiresSearchHandler;
}();
/** Start TiresSearchHandler */


$(document).ready(function () {
  new TiresSearchHandler();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

},[271]);


// WEBPACK FOOTER //
// frontoffice_tires.js